import React, { useEffect } from 'react';
import { Grid } from '@mui/material';

import TabsHeader from '@shared/components/TabsHeader';
import PlatesList from '@shared/components/PlatesList';

import ImageSlider from '@shared/components/ImageSlider';

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const typePlate = 2;

  return (
    <>
      <TabsHeader site={typePlate} />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        className="minWebPadding"
        style={{ backgroundColor: '#F2F2F2', paddingBottom: '50px' }}
      >
        <ImageSlider />

        <PlatesList
          title="Paquetes"
          IdServiceType={4}
          isGrid={true}
          isFilter={true}
          typePlate={typePlate}
        />
      </Grid>
    </>
  );
};
